import { render, staticRenderFns } from "./EditVolumeModal.vue?vue&type=template&id=bd2c3aa4&scoped=true&"
import script from "./EditVolumeModal.vue?vue&type=script&lang=js&"
export * from "./EditVolumeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditVolumeModal.vue?vue&type=style&index=0&id=bd2c3aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2c3aa4",
  null
  
)

export default component.exports